import React from "react";
import { NavLink } from "react-router-dom";

const menus = [
    { name: "Overview", path: "overview" },
    { name: "Ethernet", path: "ethernet" },
    { name: "PON", path: "pon" },
    { name: "ONU", path: "onu" },
    { name: "Advanced", path: "advanced" },
    { name: "VLAN", path: "vlan" },
    { name: "Service Port", path: "service-port" },
    { name: "DBA", path: "dba" },
    { name: "Profiles", path: "profiles" },
    { name: "Alarm", path: "alarm" },
    { name: "Logs", path: "logs" },
    { name: "Settings", path: "settings" }
];

export default function DeviceNavigation() {

    return (

        <div className="device-navigation">

            {menus.map((menu) => (

                <NavLink
                    key={menu.path}
                    to={menu.path}
                    className={({ isActive }) =>
                        isActive
                            ? "device-nav-item active"
                            : "device-nav-item"
                    }
                >
                    {menu.name}
                </NavLink>

            ))}

        </div>

    );

}